<template>
  <div class="loginPage">
    <TopBack :title="$t('lang.common.LoginAndRegister')" :handelBack="handelBack"/>
    <div class="bannerPart">
      <div class="box"><img src="../../assets/images/login/fourPointedStar.svg" alt=""/><span>{{
          $t('lang.login.training')
        }}</span>
      </div>
      <div class="font">{{ $t('lang.login.welcome') }}</div>
    </div>
    <div class="loginPart">
      <div class="mobileNum">
        <div class="title">{{ $t('lang.login.mobile') }}</div>
        <div class="phone-wrap">
          <div class="country-select" @click.stop="showCountryPop = true">
            <img class="country-flag" src="../../assets/images/login/IndiaFlag.svg" alt="in">
            <span class="country-code">+91</span>
            <svg class="arrow-down" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M6 9l6 6 6-6"/>
            </svg>
          </div>
          <div v-if="showCountryPop" class="country-pop">
            <div
              v-for="item in countryList"
              :key="item.code"
              class="country-item"
              @click="currentCountry = item; showCountryPop = false"
            >
              <img class="country-flag-sm" src="../../assets/images/login/IndiaFlag.svg" alt="">
              <span>{{ item.label }} {{ item.code }}</span>
            </div>
          </div>
          <div class="divider"></div>
          <input class="phone-input" type="text" :placeholder="$t('lang.login.mobile')" v-model="tel" id="tel"
                 @input="limitInputLength()">
        </div>
      </div>
      <div class="verificationCode" v-show="picSwitch&&countdown<=0">
        <div class="title">
          <img src="../../assets/images/login/shield.svg" alt=""/>
          <span>{{ $t('lang.login.check') }}</span>
        </div>
        <div class="inputText">
          <input type="text" v-model="pictureCode" :placeholder="$t('lang.login.enter')"
                 @input="limitLength('pictureCode',4)"/>
          <div class="captcha-box" @click="initPicture">
            <img :src="codePicture" class="pic" alt=""/>
            <div class="refresh"><img src="../../assets/images/login/refresh.svg" alt=""/></div>
          </div>
        </div>
      </div>
      <div class="otp">
        <div class="title">
          <div class="enterOtp">{{ $t('lang.login.enterOtp') }}</div>
          <div class="resend" v-if="countdown <= 0" style="background: var(--middleBlue);color: var(--white)"
               @click="getSns()">
            <div>{{ $t('lang.login.send') }}</div>
          </div>
          <div class="resend" v-else>
            <img src="../../assets/images/login/alarm.svg" alt=""/>
            <div>{{ $t('lang.login.resendText') + `${countdown}s` }}</div>
          </div>
        </div>
        <div class="inputText">
          <input
            v-for="(d, i) in otpBoxes"
            :key="i"
            :ref="'otpBox' + i"
            class="otp-item"
            type="tel"
            maxlength="1"
            inputmode="numeric"
            v-model="otpBoxes[i]"
            @input="onOtpInput(i)"
            @keydown.backspace="onOtpBackspace(i, $event)"
            @paste="onOtpPaste($event)"/>
        </div>
        <div class="tip" v-show="tip">{{ tip }}</div>
      </div>
      <div class="button" @click="login"> {{ $t('lang.login.login') }}</div>
      <GoogleLogin :LoginMethod="LoginByGoogle"/>
    </div>
    <template>
      <div class="bottom-wrap">
        <div class="feature-row">
          <div class="feature-card">
            <div class="icon-box">
              <img src="../../assets/images/login/leftCard.svg" alt=""/>
            </div>
            <div class="text-group">
              <div class="title">{{ $t('lang.login.tip1') }}</div>
              <div class="desc">{{ $t('lang.login.tip2') }}</div>
            </div>
          </div>
          <div class="feature-card">
            <div class="icon-box">
              <img src="../../assets/images/login/rightCard.svg" alt=""/>
            </div>
            <div class="text-group">
              <div class="title">{{ $t('lang.login.tip3') }}</div>
              <div class="desc">{{ $t('lang.login.tip4') }}</div>
            </div>
          </div>
        </div>

        <div class="security-bar">
          <img src="../../assets/images/login/lock.svg" alt=""/>
          <span>{{ $t('lang.login.security') }}</span>
        </div>

        <div class="agreement-tip">
          <span>{{ $t('lang.login.agreement')[0] }}</span>
          <span  class="a" @click="goto('Terms')">{{ $t('lang.login.agreement')[1] }}</span>
          <span>{{ $t('lang.login.agreement')[2] }}</span>
          <span  class="a" @click="goto('Privacy')">{{ $t('lang.login.agreement')[3] }}</span>.
        </div>
      </div>
    </template>

  </div>
</template>
<script>
import {Toast} from 'mint-ui'
import request from '@/service'
import {LogUtils} from '@/utils'
import {mapMutations} from 'vuex'
import TopBack from '@/components/TopBack/index'
import GoogleLogin from '@/components/GoogleAuth/index'

export default {
  name: 'Login',
  watch: {},
  data () {
    return {
      tel: '',
      sns: '',
      otpBoxes: ['', '', '', ''],
      tip: '',
      hasSendOtp: false,
      countdown: 0,
      picSwitch: false,
      codePicture: '',
      visitorCode: '',
      pictureCode: '',
      showCountryPop: false,
      countryList: [
        {
          label: 'India',
          code: '+91',
          flag: 'in'
        }
      ],
      currentCountry: {
        label: 'India',
        code: '+91',
        flag: 'in'
      }
    }
  },
  components: {
    TopBack,
    GoogleLogin
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fromRoute = from.name
      vm.setLoginStatus('login')
    })
  },
  async mounted () {
    this.visitorCode = await LogUtils.getVisitorCode()
    this.initPicture()
    document.addEventListener('click', this.handleClickOutside)
  },
  methods: {
    ...mapMutations({
      setInternation: 'setInternation',
      setInternationName: 'setInternationName',
      setLocale: 'setLocale',
      setLoginStatus: 'setLoginStatus'
    }),
    handelBack () {
      this.goto('Home')
    },
    goto (route) {
      this.$router.push(route)
    },
    autoSnsText (index) {
      if (!this.sns) {
        return ''
      }
      return this.sns.charAt(index)
    },
    onOtpInput (i) {
      // 仅保留数字
      this.otpBoxes[i] = (this.otpBoxes[i] || '').replace(/\D/g, '').slice(0, 1)
      // 同步到 sns
      this.sns = this.otpBoxes.join('')
      // 自动跳到下一格
      if (this.otpBoxes[i] && i < this.otpBoxes.length - 1) {
        this.focusOtpBox(i + 1)
      }
      // 填满4位自动登录
      if (this.sns.length === 4 && this.tel) {
        this.login()
      }
    },
    onOtpBackspace (i, e) {
      if (!this.otpBoxes[i] && i > 0) {
        e.preventDefault()
        this.$set(this.otpBoxes, i - 1, '')
        this.sns = this.otpBoxes.join('')
        this.focusOtpBox(i - 1)
      }
    },
    onOtpPaste (e) {
      e.preventDefault()
      const text = (e.clipboardData || window.clipboardData).getData('text') || ''
      const digits = text.replace(/\D/g, '').slice(0, 4)
      if (!digits) return
      for (let i = 0; i < 4; i++) {
        this.$set(this.otpBoxes, i, digits[i] || '')
      }
      this.sns = digits
      const nextIdx = Math.min(digits.length, 3)
      this.focusOtpBox(nextIdx)
      if (digits.length >= 4) {
        this.$nextTick(() => this.login())
      }
    },
    focusOtpBox (i) {
      this.$nextTick(() => {
        const ref = this.$refs['otpBox' + i]
        if (ref && ref[0]) ref[0].focus()
      })
    },
    initPicture () {
      const url = '/api/account/get/captcha'
      request('get', url, {}).then(result => {
        let res = result.data
        if (res) {
          this.picSwitch = res.enabled
          this.codePicture = res.captcha
          this.captchaKey = res.captchaKey
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getSns () {
      if (this.countdown > 0) {
        Toast(this.$t('lang.login.tooOften').replace('{seconds}', this.countdown))
        return
      }
      if (!this.tel) {
        Toast(this.$t('lang.login.invalid'))
        return
      }
      if (this.picSwitch && !this.pictureCode) {
        Toast('Invalid captcha!')
        return
      }
      this.hasSendOtp = true
      // 发送OTP埋点
      const url = '/api/account/send/sns'
      const data = {
        captcha: this.pictureCode,
        captchaKey: this.captchaKey,
        mobile: this.tel.replace(/\s/g, '')
      }
      request('post', url, data).then(res => {
        this.sns = ''
        this.otpBoxes = ['', '', '', '']
        if (res && res.message) {
          Toast(res.message)
        }
        if (res && res.code === 200) {
          if (res.message === 'success') {
            this.countdown = 60
            this.countdownTimer()
            this.sns = res.CodeForTestOnly
          }
        }
      }).catch(() => {
        LogUtils.saveUserEventParams('sendSnsError', '', -1, '{visitorCode:' + this.visitorCode + '}')
        if (this.picSwitch) {
          this.pictureCode = ''
          this.initPicture()
        }
        Toast('Fail')
      })
    },
    /****
     * 2021-08-04 C007 注册成功重设7天Gift和24小时充值送弹框状态
     */
    login () {
      if (!this.tel) {
        Toast(this.$t('lang.login.invalid'))
        return
      }
      if (this.countdown <= 0) {
        Toast(this.$t('lang.login.invalidCode'))
        return
      }
      const url = '/api/account/login'
      const data = {
        campaignId: localStorage.getItem('cid'),
        mobile: this.tel.replace(/\s/g, ''),
        shareCode: this.inviteCode,
        snsCode: this.sns,
        userType: 0,
        visitorCode: this.visitorCode
      }
      request('post', url, data).then(res => {
        if (res && res.code === 200 && res.data) {
          Toast(this.$t('lang.common.success'))
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          if (userInfo) {
            if (userInfo.token) {
              localStorage.setItem('LHP', userInfo.token)
            }

            if (userInfo.campaignId) {
              localStorage.setItem('cid', userInfo.campaignId)
            }
          }
          this.fetchNext()
        } else {
          Toast(res.message.CAPITALIZE)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    fetchNext () {
      if (this.fromRoute === 'Promotion' || this.fromRoute === 'Support' || this.fromRoute === 'Earn') {
        this.$router.go(-1)
      } else {
        this.$router.push('/Home')
      }
    },
    LoginByGoogle (token, googleId, mail) {
      let data = {
        campaignId: localStorage.getItem('cid'),
        credential: token,
        shareCode: this.inviteCode,
        visitorCode: this.visitorCode
      }
      request('post', '/api/account/google/login', data).then(res => {
        if (res && res.code === 200 && res.data) {
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          if (userInfo) {
            if (userInfo.token) {
              localStorage.setItem('LHP', userInfo.token)
            }

            if (userInfo.campaignId) {
              localStorage.setItem('cid', userInfo.campaignId)
            }
          }
          this.fetchNext()
        } else {
          Toast(res.message)
        }
      }).catch(err => {
        Toast('fail')
        console.log(err)
      })
    },
    handleClickOutside () {
      this.showCountryPop = false
    },
    limitLength (name, len) {
      // 拿到当前值，只保留数字
      if (name === 'pictureCode') {
        // pictureCode只允许字母和数字
        this[name] = this[name].replace(/[^a-zA-Z0-9]/g, '')
      }
      // 拿到当前值，只保留数字
      if (name === 'sns' && this[name].length === len) {
        this.login()
        return
      }
      if (this[name].length > len) {
        this[name] = this[name].slice(0, len)
      }
    },
    limitInputLength () {
      // 拿到当前值，只保留数字
      let digits = this.tel.replace(/\D/g, '')
      // 第4位起为 54321 时允许 12 位，否则上限 10 位
      const max = digits.length >= 8 && digits.slice(3, 8) === '54321' ? 12 : 10
      if (digits.length > max) {
        digits = digits.slice(0, max)
      }
      // 格式化：每5位加空格
      const formatted = digits.replace(/(\d{5})(?=\d)/g, '$1 ')
      this.tel = formatted
    },
    countdownTimer () {
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1
          this.countdownTimer()
        }, 1000)
      } else if (this.countdown === 0) {
        this.initPicture()
        this.pictureCode = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.loginPage {
  position: relative;
  padding-top: calc(60vw / 3.6);
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--primary-color);
  padding-bottom: calc(10vw / 3.6);

  .bannerPart {
    position: relative;
    width: 100vw;
    height: calc(97vw / 3.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: calc(14vw / 3.6);
      height: auto;
      margin-right: calc(4vw / 3.6);
    }

    .box {
      width: calc(178vw / 3.6);
      height: calc(26vw / 3.6);
      line-height: calc(26vw / 3.6);
      background: var(--lightBlue);
      border: calc(1vw / 3.6) solid var(--blue);
      color: var(--middleBlue);
      border-radius: 13vw;
      font-size: calc(12vw / 3.6);
      font-family: Inter;
      font-weight: 600;
      letter-spacing: 0.02em;
      display: flex;
      justify-content: center;
    }

    .font {
      margin-top: calc(10vw / 3.6);
      font-family: Inter;
      font-weight: 800;
      font-size: calc(23vw / 3.6);
      line-height: calc(23vw / 3.6);
      letter-spacing: -0.05em;
      text-align: center;
      vertical-align: middle;
      color: var(--black);
    }
  }

  .loginPart {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: calc(326vw / 3.6);
    height: max-content;
    background: var(--container);
    padding: calc(16vw / 3.6);
    border-radius: calc(16vw / 3.6);
    border: calc(1vw / 3.6) solid #E2E8F0B2;

    .mobileNum {
      position: relative;
      .title {
        color: var(--thinFont);
        font-family: Inter;
        font-weight: 500;
        font-size: calc(12vw / 3.6);
        line-height: calc(16vw / 3.6);
      }

      .phone-wrap {
        margin-top: calc(6vw / 3.6);
        display: flex;
        align-items: center;
        width: 100%;
        max-width: calc(292vw / 3.6);
        height: calc(42vw / 3.6);
        background: var(--input);
        border-radius: calc(12vw / 3.6);
        border: calc(1vw / 3.6) solid #e8ebf2;
        margin-bottom: calc(32vw / 3.6);
        overflow: visible;

        .country-select {
          position: relative;
          display: flex;
          align-items: center;
          gap: calc(6vw / 3.6); /* 国旗 和 +91 间距，和之前标注一致 */
          padding: 0 calc(10vw / 3.6);
          height: max-content;
          cursor: pointer;
          white-space: nowrap;
        }

        .country-flag {
          width: calc(16vw / 3.6);
          height: auto;
          border-radius: calc(3vw / 3.6);
          object-fit: cover;
        }

        .country-code {
          color: #1d2433;
          font-family: Inter;
          font-weight: 600;
          text-align: center;
          vertical-align: middle;
          font-size: calc(12vw / 3.6);
          line-height: calc(42vw / 3.6);
        }

        .arrow-down {
          width: calc(16vw / 3.6);
          height: calc(16vw / 3.6);
          margin-left: calc(4vw / 3.6);
          color: #555e70;
        }

        .divider {
          width: calc(1vw / 3.6);
          height: calc(24vw / 3.6);
          background: #dde1ea;
        }

        .phone-input {
          flex: 1;
          height: 100%;
          border: none;
          outline: none;
          background: transparent;
          padding: 0 calc(14vw / 3.6);;
          font-size: calc(14vw / 3.6);;
          font-weight: 600;
          color: #1d2433;
          letter-spacing: 0em;
        }

        .phone-input::placeholder {
          color: #868fa4;
        }
      }

      /* 下拉弹窗面板 */

      .country-pop {
        position: absolute;
        top: calc(68vw / 3.6);
        left: 0;
        min-width: calc(80vw / 3.6);
        background: #fff;
        border-radius:  calc(12vw / 3.6);
        box-shadow: 0 calc(4vw / 3.6) calc(16vw / 3.6) rgba(0, 0, 0, 0.12);
        padding: calc(8vw / 3.6) 0;
        z-index: 999;
      }

      .country-item {
        display: flex;
        align-items: center;
        gap: calc(2vw / 3.6);
        padding: calc(5vw / 3.6) calc(8vw / 3.6);
        cursor: pointer;
        font-size: calc(15vw / 3.6);
      }

      .country-item:hover {
        background: #f3f5f9;
      }

      .country-flag-sm {
        width: calc(24vw / 3.6);
        height: calc(17vw / 3.6);
        border-radius: calc(2vw / 3.6);
      }
    }

    // verificationCode Security Check
    .verificationCode {
      width: 100%;
      padding: calc(12vw / 3.6) calc(10vw / 3.6);
      background: #f7f9fc;
      border-radius: calc(14vw / 3.6);
      border: calc(1vw / 3.6) solid #e9ecf3;
      margin-bottom: calc(17vw / 3.6);

      .title {
        display: flex;
        align-items: center;
        font-weight: 600;
        gap: calc(6vw / 3.6);
        font-size: calc(12vw / 3.6);
        color: var(--thinFont);
        margin-bottom: calc(8vw / 3.6);
      }

      .inputText {
        display: flex;
        gap: calc(10vw / 3.6);
        align-items: center;

        input {
          flex: 1;
          width: calc(142vw / 3.6);
          height: calc(34vw / 3.6);
          background: #fff;
          border-radius: calc(8vw / 3.6);
          border: calc(1vw / 3.6) solid #e9ecf3;
          padding: 0 calc(14vw / 3.6);
          font-size: calc(12vw / 3.6);
          outline: none;
          text-transform: uppercase;
        }

        .captcha-box {
          position: relative;
          display: flex;
          align-items: center;
          width: calc(116vw / 3.6);
          height: calc(34vw / 3.6);
          background: #fff;
          border-radius: calc(8vw / 3.6);
          border: calc(1vw / 3.6) solid #d9ddf7;
          overflow: hidden;
          padding-left: calc(4vw / 3.6);

          .pic {
            width: calc(80vw / 3.6);
            height: auto;
          }

          .refresh {
            position: absolute;
            right: calc(4vw / 3.6);
            top: 50%;
            transform: translateY(-50%);
            width: calc(24vw / 3.6);
            height: calc(24vw / 3.6);
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 100%;
              height: auto;
            }
          }
        }
      }
    }

    // otp
    .otp {
      width: 100%;
      margin-bottom: calc(24vw / 3.6);

      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: calc(12vw / 3.6);
        font-weight: 500;

        .enterOtp {
          font-family: Inter;
          font-size: calc(12vw / 3.6);
          color: #6b7280;
          color: var(--thinFont);
        }

        .resend {
          padding: calc(2vw/3.6) calc(8vw/3.6);
          gap: calc(4vw/3.6);
          background: #EFF6FF;
          font-family: Inter;
          font-size: calc(11vw / 3.6);
          height: calc(21vw / 3.6);
          line-height: calc(21vw / 3.6);
          color: #2563eb;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: calc(9999vw / 3.6);
        }
      }

      .inputText {
        display: flex;
        gap: calc(12vw / 3.6);

        .otp-item {
          flex: 1;
          border: calc(1vw / 3.6) solid #E2E8F0;
          height: calc(48vw / 3.6);
          width: calc(64vw / 3.6);
          background: var(--inputBox);
          border-radius: calc(14vw / 3.6);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: calc(18vw / 3.6);
          color: #1d2433;
          text-align: center;
          outline: none;
          caret-color: var(--darkBlue);
        }

        .otp-item:focus {
          border-color: var(--darkBlue);
          background: var(--container);
        }
      }

      .tip {
        margin-top: calc(12vw / 3.6);
        font-size: calc(14vw / 3.6);
        color: #2563eb;
      }
    }

    // button
    .button {
      width: calc(292vw / 3.6);
      height: calc(48vw / 3.6);
      background: var(--darkBlue);
      color: var(--white);
      border-radius: calc(12vw / 3.6);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(14vw / 3.6);
      font-weight: 500;
    }
  }

  .bottom-wrap {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: calc(326vw / 3.6);
    height: max-content;
  }

  .feature-row {
    margin-top: calc(10vw / 3.6);
    display: flex;
    gap: 3.3333vw;
  }

  .feature-card {
    flex: 1;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 3.3333vw;
    width: calc(158vw / 3.6);
    height: calc(54vw / 3.6);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: calc(1vw / 3.6) solid rgba(226, 232, 240, 0.8);

    .icon-box {
      position: relative;
      width: calc(32vw / 3.6);
      height: calc(32vw / 3.6);
      border-radius: 2.2222vw;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: calc(10vw / 3.6);

      svg {
        width: 5vw;
        height: 5vw;
        fill: #2563eb;
      }
    }

    .text-group {
      .title {
        white-space: nowrap;
        font-family: 'Inter';
        font-weight: 700;
        font-size: calc(11vw / 3.6);
        color: #1E293B;
      }

      .desc {
        white-space: nowrap;
        font-size: calc(10vw / 3.6);
        color: #6b7280;
        margin-top: 0.5556vw;
      }
    }
  }

  .security-bar {
    margin-top: 4.4444vw;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    width: calc(326vw / 3.6);
    height: calc(34vw / 3.6);
    background: #EEF2FB;
    border: calc(1vw / 3.6) solid #DBEAFE;
    border-radius: calc(9999vw / 3.6);
    white-space: nowrap;

    img {
      width: calc(8.75vw / 3.6);
      height: auto;
      margin: 0 calc(6vw / 3.6) 0 calc(17.5vw / 3.6)
    }

    span {
      font-size: calc(10.5vw/3.6);
      font-family: 'Inter';
      font-weight: 500;
      color: #4b5563;
    }
  }

  .agreement-tip {
    margin-top: 5.5556vw;
    width: calc(292vw / 3.6);
    text-align: center;
    font-size: calc(10vw / 3.6);
    color: #6b7280;

    .a {
      color: #2563eb;
      text-decoration: none;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Login/index.vue